(function () {
  function initCultLaunchNav() {
    var header = document.getElementById('cl-site-header');
    var toggle = document.getElementById('cl-nav-toggle');
    var menu = document.getElementById('cl-mobile-nav');
    var overlay = document.getElementById('cl-mobile-nav-overlay');

    if (!header || !toggle || !menu || !overlay || header.dataset.navReady === 'true') {
      return;
    }

    header.dataset.navReady = 'true';

    var closeMenu = function () {
      header.classList.remove('is-nav-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      menu.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cl-nav-open');
    };

    var openMenu = function () {
      header.classList.add('is-nav-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      menu.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cl-nav-open');
    };

    toggle.addEventListener('click', function (event) {
      event.preventDefault();

      if (header.classList.contains('is-nav-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    overlay.addEventListener('click', closeMenu);

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && header.classList.contains('is-nav-open')) {
        closeMenu();
      }
    });

    window.matchMedia('(min-width: 990px)').addEventListener('change', function (event) {
      if (event.matches) {
        closeMenu();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCultLaunchNav);
  } else {
    initCultLaunchNav();
  }

  document.addEventListener('shopify:section:load', initCultLaunchNav);
})();
